// src/components/LegalDocuments.jsx
import React from 'react';
import { X, FileText, AlertCircle, Building, Phone, Mail, Globe } from 'lucide-react';

// Modal Bileşeni
export function LegalModal({ isOpen, onClose, type }) {
  if (!isOpen) return null;

  const companyInfo = {
    name: "Trona Gıda Pazarlama Limited Şirketi",
    address: "Emek Mah. 3022 Sk. No: 2A Manavgat / Antalya",
    phone: "0535 643 41 81",
    email: "info@tronapazarlama.com",
    website: "https://tronapazarlama.com",
    mersis: "0859111653600001",
    tradeRegistryNo: "12847",
    taxOffice: "Manavgat Vergi Dairesi",
    taxNo: "8591116536",
    owner: "Ömer Şahin"
  };

  return (
    <div className="legal-modal-overlay" onClick={onClose}>
      <div className="legal-modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <X size={16} />
        </button>
        
        <div className="legal-modal-body">
          {type === 'pre-information' ? (
            <PreInformationContent companyInfo={companyInfo} />
          ) : (
            <DistanceSalesContent companyInfo={companyInfo} />
          )}
        </div>
      </div>
      <style>{modalStyles}</style>
    </div>
  );
}

// Ön Bilgilendirme Formu İçeriği
function PreInformationContent({ companyInfo }) {
  return (
    <div className="legal-document">
      <div className="document-header">
        <FileText size={32} />
        <h1>ÖN BİLGİLENDİRME FORMU</h1>
        <p className="document-date">Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
      </div>

      <div className="company-info-box">
        <h3><Building size={18} /> SATICI BİLGİLERİ</h3>
        <div className="info-grid">
          <div className="info-item">
            <strong>Ünvan:</strong>
            <span>{companyInfo.name}</span>
          </div>
          <div className="info-item">
            <strong>Adres:</strong>
            <span>{companyInfo.address}</span>
          </div>
          <div className="info-item">
            <strong>Telefon:</strong>
            <span>{companyInfo.phone}</span>
          </div>
          <div className="info-item">
            <strong>E-posta:</strong>
            <span>{companyInfo.email}</span>
          </div>
          <div className="info-item">
            <strong>MERSİS No:</strong>
            <span>{companyInfo.mersis}</span>
          </div>
          <div className="info-item">
            <strong>Vergi Dairesi:</strong>
            <span>{companyInfo.taxOffice}</span>
          </div>
        </div>
      </div>

      <section className="document-section">
        <h2>1. ÜRÜN/HİZMET BİLGİLERİ</h2>
        <p>
          Satın almak istediğiniz ürün/hizmetlerin temel özellikleri, satış fiyatı, 
          ödeme şekli ve teslim koşulları sepet ve ödeme sayfalarında detaylı olarak 
          gösterilmektedir. Bu bilgileri sipariş vermeden önce kontrol etmeniz önemlidir.
        </p>
        <div className="info-box">
          <AlertCircle size={18} />
          <p>
            <strong>Önemli:</strong> Ürün açıklamaları, görseller ve fiyatlar 
            sipariş anında geçerli olan bilgilerdir. Kampanyalı ürünlerde stok 
            durumu ve kampanya süresi göz önünde bulundurulmalıdır.
          </p>
        </div>
      </section>

      <section className="document-section">
        <h2>2. ÖDEME VE TESLİMAT</h2>
        
        <h3>2.1. Ödeme Yöntemleri</h3>
        <ul>
          <li>Kredi Kartı / Banka Kartı (Visa, Mastercard, Troy)</li>
        </ul>

        <h3>2.2. Teslimat Süreleri</h3>
        <ul>
          <li><strong>Standart Kargo:</strong> 3-5 iş günü</li>
        </ul>

        <div className="warning-box">
          <AlertCircle size={18} />
          <p>
            Sipariş onayından sonra kargo firmasına teslim süresi maksimum 3 iş günüdür. 
            Öngörülemeyen hava koşulları, doğal afetler veya kargo firmasından kaynaklı 
            gecikmelerden firmamız sorumlu değildir.
          </p>
        </div>
      </section>

      <section className="document-section">
        <h2>3. CAYMA HAKKI</h2>
        <p>
          6502 sayılı Tüketicinin Korunması Hakkında Kanun uyarınca, alıcı olarak 
          aşağıdaki koşullarda <strong>7 gün içerisinde</strong> cayma hakkınız bulunmaktadır:
        </p>

        <h3>3.1. Cayma Hakkının Kullanımı</h3>
        <ul>
          <li>Ürünü teslim aldığınız tarihten itibaren 7 gün içinde</li>
          <li>Ürün kullanılmamış, ambalajı açılmamış ve hasarsız olmalıdır</li>
          <li>Fatura aslı ile birlikte iade edilmelidir</li>
          <li>Cayma bildirimini e-posta veya telefon ile yapabilirsiniz</li>
        </ul>

        <h3>3.2. Cayma Hakkı Kullanılamayan Ürünler</h3>
        <ul>
          <li>Kişiye özel üretilen veya kişiselleştirilen ürünler</li>
          <li>Hijyen ve sağlık açısından uygun olmayan, ambalajı açılmış ürünler</li>
          <li>Teslimattan sonra hızla bozulabilen veya son kullanma tarihi geçebilecek ürünler</li>
          <li>Elektronik ortamda anında ifa edilen hizmetler</li>
          <li>Ses veya görüntü kayıtları, yazılım ve bilgisayar sarf malzemeleri (ambalajı açılmışsa)</li>
        </ul>

        <div className="success-box">
          <p>
            <strong>İade Süreci:</strong> Cayma hakkınızı kullandığınızda, ürün iadenizi 
            aldığımız tarihten itibaren 7 gün içerisinde ödemeniz tarafınıza iade edilir.
          </p>
        </div>
      </section>

      <section className="document-section">
        <h2>4. TÜKETİCİ HİZMETLERİ</h2>
        <p>Sorularınız, şikayetleriniz veya önerileriniz için:</p>
        <div className="contact-info">
          <div className="contact-item">
            <Phone size={18} />
            <div>
              <strong>Telefon</strong>
              <span>{companyInfo.phone}</span>
            </div>
          </div>
          <div className="contact-item">
            <Mail size={18} />
            <div>
              <strong>E-posta</strong>
              <span>{companyInfo.email}</span>
            </div>
          </div>
          <div className="contact-item">
            <Globe size={18} />
            <div>
              <strong>Web Sitesi</strong>
              <span>{companyInfo.website}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="document-section">
        <h2>5. UYUŞMAZLIK ÇÖZÜMÜ</h2>
        <p>
          İşbu sözleşmeden doğabilecek her türlü uyuşmazlığın çözümünde; 
          Sanayi ve Ticaret Bakanlığı'nca her yıl Aralık ayında belirlenen parasal 
          sınırlar dahilinde tüketicinin yerleşim yerinin bulunduğu veya tüketici 
          işleminin yapıldığı yerdeki <strong>Tüketici Hakem Heyetleri</strong> ile 
          <strong>Tüketici Mahkemeleri</strong> yetkilidir.
        </p>
      </section>

      <div className="document-footer">
        <p>
          Bu form, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve 
          Mesafeli Sözleşmeler Yönetmeliği uyarınca hazırlanmıştır.
        </p>
        <p className="signature">
          <strong>{companyInfo.name}</strong>
        </p>
      </div>
    </div>
  );
}

// Mesafeli Satış Sözleşmesi İçeriği
function DistanceSalesContent({ companyInfo }) {
  return (
    <div className="legal-document">
      <div className="document-header">
        <FileText size={32} />
        <h1>MESAFELİ SATIŞ SÖZLEŞMESİ</h1>
        <p className="document-date">Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}</p>
      </div>

      <section className="document-section">
        <h2>MADDE 1 - TARAFLAR</h2>
        
        <h3>1.1. SATICI</h3>
        <div className="party-info">
          <p><strong>Ünvan:</strong> {companyInfo.name}</p>
          <p><strong>Adres:</strong> {companyInfo.address}</p>
          <p><strong>Telefon:</strong> {companyInfo.phone}</p>
          <p><strong>E-posta:</strong> {companyInfo.email}</p>
          <p><strong>MERSİS No:</strong> {companyInfo.mersis}</p>
        </div>

        <h3>1.2. ALICI</h3>
        <p>
          Sipariş esnasında kayıt altına alınan ve aşağıda "ALICI" olarak anılacak 
          gerçek veya tüzel kişi. Alıcı bilgileri sipariş formunda belirtilmiştir.
        </p>
      </section>

      <section className="document-section">
        <h2>MADDE 2 - KONU</h2>
        <p>
          İşbu Sözleşme, ALICI'nın SATICI'ya ait <strong>{companyInfo.website}</strong> 
          internet sitesi üzerinden elektronik ortamda siparişini verdiği aşağıda 
          nitelikleri ve satış fiyatı belirtilen ürün/ürünlerin satışı ve teslimi ile 
          ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli 
          Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerini 
          düzenler.
        </p>
      </section>

      <section className="document-section">
        <h2>MADDE 3 - SÖZLEŞME KONUSU ÜRÜN/ÜRÜNLER BİLGİLERİ</h2>
        <p>
          Sözleşme konusu mal/hizmetlerin cinsi, miktarı, marka/modeli, rengi, satış 
          bedeli, ödeme şekli, teslim alacak kişi gibi tüm ön bilgiler ve özellikler 
          sipariş formunda ve sipariş onay e-postasında detaylı olarak belirtilmiştir.
        </p>
        
        <div className="info-box">
          <AlertCircle size={18} />
          <p>
            Listelenen ve sitede ilan edilen fiyatlar satış fiyatıdır. İlan edilen 
            fiyatlar ve vaatler güncelleme yapılana ve değiştirilene kadar geçerlidir.
          </p>
        </div>
      </section>

      <section className="document-section">
        <h2>MADDE 4 - GENEL HÜKÜMLER</h2>
        
        <h3>4.1. Sipariş Onayı</h3>
        <p>
          ALICI, internet sitesi üzerinden verdiği sipariş ile işbu sözleşmenin tüm 
          koşullarını kabul ettiğini beyan ve taahhüt eder. Sipariş onayı ile birlikte 
          sözleşme kurulmuş sayılır.
        </p>

        <h3>4.2. Fiyat ve Ödeme</h3>
        <ul>
          <li>Tüm fiyatlar Türk Lirası (TL) cinsindendir ve KDV dahildir</li>
          <li>Kampanyalı ürünlerde indirim oranları ve süreleri belirtilmiştir</li>
          <li>Kredi kartı ile yapılan ödemelerde banka taksit seçenekleri kullanılabilir</li>
          <li>Ödeme bilgileri 256-bit SSL güvenlik sertifikası ile korunmaktadır</li>
        </ul>

        <h3>4.3. Teslimat</h3>
        <p>
          Ürün/ürünler, ALICI'nın sipariş formunda belirttiği adrese 
          <strong> kargo firması aracılığıyla</strong> teslim edilir.
        </p>
        <ul>
          <li>Teslimat süresi: Siparişin onaylanmasından itibaren 3-7 iş günü</li>
          <li>Kargo ücreti: Sipariş tutarına göre değişkenlik gösterir</li>
          <li>Yurt dışı teslimatlar için özel şartlar geçerlidir</li>
        </ul>

        <div className="warning-box">
          <AlertCircle size={18} />
          <p>
            <strong>Önemli:</strong> Teslim edilecek kişi ile sipariş veren kişinin 
            farklı olması durumunda, teslim edilecek kişinin teslimatı kabul etmemesinden 
            doğacak sorumluluklar ALICI'ya aittir.
          </p>
        </div>
      </section>

      <section className="document-section">
        <h2>MADDE 5 - CAYMA HAKKI</h2>
        
        <h3>5.1. Cayma Hakkı Süresi</h3>
        <p>
          ALICI, sözleşme konusu ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa 
          tesliminden itibaren <strong>14 (on dört) gün</strong> içinde, SATICI'ya 
          bildirmek şartıyla hiçbir hukuki ve cezai sorumluluk üstlenmeksizin ve hiçbir 
          gerekçe göstermeksizin malı reddederek sözleşmeden cayma hakkını kullanabilir.
        </p>

        <h3>5.2. Cayma Hakkının Kullanımı</h3>
        <p>Cayma hakkını kullanmak için:</p>
        <ol>
          <li>7 gün içinde SATICI'ya yazılı veya e-posta ile bildirimde bulunmalısınız</li>
          <li>Ürünü kullanmamış, ambalajını açmamış olmalısınız</li>
          <li>Fatura aslını iade etmelisiniz</li>
          <li>Ürünü kargo ile iade etmelisiniz (kargo ücreti ALICI'ya aittir)</li>
        </ol>

        <h3>5.3. Cayma Hakkı Kullanılamayan Ürünler</h3>
        <p>
          Aşağıdaki ürün ve hizmetlerde cayma hakkı kullanılamaz:
        </p>
        <ul>
          <li>Fiyatı finansal piyasalardaki dalgalanmalara bağlı olan ürünler</li>
          <li>ALICI'nın istekleri veya kişisel ihtiyaçları doğrultusunda hazırlanan ürünler</li>
          <li>Çabuk bozulabilen veya son kullanma tarihi geçebilecek ürünler</li>
          <li>Teslimden sonra ambalajı açılmış ürünler (hijyen ve sağlık açısından)</li>
          <li>Teslimden sonra başka ürünlerle karışan ve ayrıştırılması mümkün olmayan ürünler</li>
          <li>Gazete, dergi gibi süreli yayınlar</li>
          <li>Elektronik ortamda anında ifa edilen hizmetler</li>
          <li>Ses veya görüntü kayıtları, yazılım, DVD gibi ürünler (ambalajı açılmışsa)</li>
        </ul>

        <h3>5.4. Bedelin İadesi</h3>
        <p>
          Cayma hakkının kullanılması halinde, ürünün SATICI'ya ulaşmasından itibaren 
          <strong> 7 gün içerisinde</strong> ödenen toplam tutar, hiçbir kesinti 
          yapılmadan ALICI'ya iade edilir. Ürün iadesi için yapılan kargo masrafı 
          ALICI tarafından karşılanır.
        </p>
      </section>

      <section className="document-section">
        <h2>MADDE 6 - SATICI'NIN HAK VE YÜKÜMLÜLÜKLERİ</h2>
        <p>SATICI;</p>
        <ul>
          <li>Sözleşme konusu ürünü eksiksiz, siparişte belirtilen niteliklere uygun ve 
              varsa garanti belgeleri ile teslim etmekle yükümlüdür</li>
          <li>Ürünün ambalajının açılmamış, bozulmamış ve ürünün kullanılmamış olması 
              şartıyla cayma hakkını kabul etmekle yükümlüdür</li>
          <li>Stokta olmayan ürünler için ALICI'yı bilgilendirmekle yükümlüdür</li>
          <li>ALICI'nın kişisel ve ödeme bilgilerini korumakla yükümlüdür</li>
        </ul>
      </section>

      <section className="document-section">
        <h2>MADDE 7 - ALICI'NIN HAK VE YÜKÜMLÜLÜKLERİ</h2>
        <p>ALICI;</p>
        <ul>
          <li>Sipariş verirken doğru ve eksiksiz bilgi vermekle yükümlüdür</li>
          <li>Ürün bedelini zamanında ödemekle yükümlüdür</li>
          <li>Ürünü teslim alırken hasarsız olup olmadığını kontrol etmelidir</li>
          <li>Cayma hakkını kullanırken ürünü kullanılmamış ve ambalajı açılmamış 
              şekilde iade etmekle yükümlüdür</li>
        </ul>
      </section>

      <section className="document-section">
        <h2>MADDE 8 - MÜCBİR SEBEPLER</h2>
        <p>
          Doğal afet, yangın, patlama, iç savaş, savaş, ayaklanma, halk hareketleri, 
          seferberlik ilanı, grev, lokavt ve salgın hastalıklar, altyapı ve internet 
          arızaları, elektrik kesintisi gibi öngörülemeyen ve tarafların kontrolü 
          dışındaki olaylar mücbir sebep sayılır. Mücbir sebep hali ortaya çıktığında 
          taraflar yükümlülüklerinden sorumlu tutulamaz.
        </p>
      </section>

      <section className="document-section">
        <h2>MADDE 9 - UYUŞMAZLIKLARIN ÇÖZÜMÜ</h2>
        <p>
          İşbu sözleşmenin uygulanmasından veya yorumlanmasından doğacak her türlü 
          uyuşmazlığın çözümünde Türkiye Cumhuriyeti yasaları uygulanır. 
          Uyuşmazlıkların çözümünde, her yıl Sanayi ve Ticaret Bakanlığı tarafından 
          ilan edilen değere kadar <strong>Tüketici Hakem Heyetleri</strong> ve 
          <strong>Tüketici Mahkemeleri</strong> yetkilidir.
        </p>
      </section>

      <section className="document-section">
        <h2>MADDE 10 - YÜRÜRLÜK</h2>
        <p>
          ALICI, site üzerinden verdiği sipariş ile işbu sözleşmenin tüm şartlarını 
          okuduğunu, anladığını ve kabul ettiğini beyan ve taahhüt eder. İşbu sözleşme 
          elektronik ortamda sipariş verildiği anda akdedilmiş ve yürürlüğe girmiştir.
        </p>
      </section>

      <div className="document-footer">
        <div className="signature-section">
          <div className="signature-box">
            <h4>SATICI</h4>
            <p><strong>{companyInfo.name}</strong></p>
            <p>{companyInfo.address}</p>
          </div>
          <div className="signature-box">
            <h4>ALICI</h4>
            <p>Elektronik onay ile kabul edilmiştir</p>
            <p className="acceptance-note">
              Sipariş tarihi ve saati kayıt altındadır
            </p>
          </div>
        </div>
        
        <div className="legal-notice">
          <p>
            Bu sözleşme 6502 sayılı Tüketicinin Korunması Hakkında Kanun, 
            Mesafeli Sözleşmeler Yönetmeliği ve ilgili mevzuat hükümleri 
            uyarınca düzenlenmiştir.
          </p>
        </div>
      </div>
    </div>
  );
}

// Modal Stilleri
const modalStyles = `
  .legal-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 10px;
    animation: fadeIn 0.2s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .legal-modal-content {
    background: #fff;
    border-radius: 20px;
    width: 100%;
    max-width: 900px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    position: relative;
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from { transform: translateY(50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  .modal-close-btn {
    position: sticky;
    top: 0;
    right: 0;
    float: right;
    background: #E5332A;
    color: #fff;
    border: none;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    margin: 20px 10px 0 0;
    transition: all 0.2s;
    margin-left: 8px;
  }

  .modal-close-btn:hover {
    background: #c72a22;
    transform: rotate(90deg);
  }

  .legal-modal-body {
    overflow-y: auto;
    max-height: calc(90vh - 20px);
    padding: 20px 40px 40px;
  }

  /* Scrollbar Styling */
  .legal-modal-body::-webkit-scrollbar {
    width: 8px;
  }

  .legal-modal-body::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .legal-modal-body::-webkit-scrollbar-thumb {
    background: #E5332A;
    border-radius: 4px;
  }

  .legal-modal-body::-webkit-scrollbar-thumb:hover {
    background: #c72a22;
  }

  /* Document Styles */
  .legal-document {
    color: #2B2B2B;
    line-height: 1.7;
  }

  .document-header {
    text-align: center;
    padding-bottom: 32px;
    border-bottom: 3px solid #E5332A;
    margin-bottom: 32px;
  }

  .document-header svg {
    color: #E5332A;
    margin-bottom: 16px;
  }

  .document-header h1 {
    font-size: 28px;
    font-weight: 700;
    color: #2B2B2B;
    margin-bottom: 8px;
  }

  .document-date {
    font-size: 14px;
    color: #868e96;
  }

  .company-info-box {
    background: #f8f9fa;
    border-left: 4px solid #E5332A;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 32px;
  }

  .company-info-box h3 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    margin-bottom: 20px;
    color: #E5332A;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .info-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .info-item strong {
    font-size: 13px;
    color: #868e96;
    font-weight: 600;
  }

  .info-item span {
    font-size: 14px;
    color: #2B2B2B;
  }

  .document-section {
    margin-bottom: 32px;
  }

  .document-section h2 {
    font-size: 20px;
    font-weight: 700;
    color: #E5332A;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid #f1f3f5;
  }

  .document-section h3 {
    font-size: 16px;
    font-weight: 600;
    color: #2B2B2B;
    margin: 20px 0 12px;
  }

  .document-section p {
    margin-bottom: 12px;
    text-align: justify;
  }

  .document-section ul,
  .document-section ol {
    margin: 12px 0;
    padding-left: 24px;
  }

  .document-section li {
    margin-bottom: 8px;
    line-height: 1.6;
  }

  .info-box,
  .warning-box,
  .success-box {
    display: flex;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    margin: 16px 0;
  }

  .info-box {
    background: #e3f2fd;
    border-left: 4px solid #2196f3;
  }

  .info-box svg {
    color: #2196f3;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .warning-box {
    background: #fff3e0;
    border-left: 4px solid #ff9800;
  }

  .warning-box svg {
    color: #ff9800;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .success-box {
    background: #e8f5e9;
    border-left: 4px solid #4caf50;
  }

  .contact-info {
    display: grid;
    gap: 16px;
    margin-top: 16px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 12px;
  }

  .contact-item svg {
    color: #E5332A;
    flex-shrink: 0;
  }

  .contact-item strong {
    display: block;
    font-size: 14px;
    margin-bottom: 4px;
    color: #2B2B2B;
  }

  .contact-item span {
    font-size: 14px;
    color: #495057;
  }

  .party-info {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 12px;
    margin: 16px 0;
  }

  .party-info p {
    margin-bottom: 8px;
    font-size: 14px;
  }

  .party-info strong {
    display: inline-block;
    min-width: 120px;
    color: #495057;
  }

  .document-footer {
    margin-top: 48px;
    padding-top: 32px;
    border-top: 2px solid #e9ecef;
  }

  .document-footer p {
    text-align: center;
    font-size: 14px;
    color: #868e96;
    margin-bottom: 12px;
  }

  .signature {
    text-align: center;
    margin-top: 24px;
    font-size: 16px !important;
    color: #E5332A !important;
  }

  .signature-section {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-bottom: 32px;
  }

  .signature-box {
    background: #f8f9fa;
    padding: 24px;
    border-radius: 12px;
    text-align: center;
  }

  .signature-box h4 {
    font-size: 14px;
    color: #868e96;
    margin-bottom: 12px;
    font-weight: 600;
  }

  .signature-box p {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .acceptance-note {
    font-size: 12px !important;
    color: #868e96 !important;
    font-style: italic;
    margin-top: 8px;
  }

  .legal-notice {
    background: #fff5f5;
    border: 1px solid #ffcdd2;
    padding: 20px;
    border-radius: 12px;
    text-align: center;
  }

  .legal-notice p {
    font-size: 13px;
    color: #c62828;
    margin: 0;
  }

  @media (max-width: 768px) {
    .legal-modal-body {
      padding: 3px;
    }

    .info-grid {
      grid-template-columns: 1fr;
    }

    .signature-section {
      grid-template-columns: 1fr;
    }

    .document-header h1 {
      font-size: 22px;
    }

    .modal-close-btn {
        width: 24px;
        height: 24px;
    }
  }
`;